// removed by extract-text-webpack-plugin
module.exports = {" _key":"widgets-web/label","root":"_14d9k-HF"};


//////////////////
// WEBPACK FOOTER
// ./src/label/styles/label.m.css
// module id = ./src/label/styles/label.m.css
// module chunks = radio